import React, { useEffect, useRef, Collapse } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as actions from '../actions/micustomeractions'
import * as appConstants from './../../../overrides/appconstants'
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions'

export default function PlanCompare() {
    const state = useSelector(state => state.miCustomerSharedReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //let quoteInformation = state.quoteInformation;
    let benefitStructure = state.benefitStructure;

    console.log('benefitStructure', benefitStructure);


    useEffect(() => {


    }, []);


    const onResetBenefitStrucutre = () => {
        document.getElementById('individualBenefitStructure').click();
        //dispatch(actions.resetBenefitStructureParams());
    }

    function renderBenefitStructure() {


        return (
            <>

                <div >



                    {benefitStructure.selectedPlans.length > 0 &&
                        <div className="table-responsive"  >
                            <table id="scroll-horizontal-datatable" className="table  table-bordered w-100 nowrap ">
                                <thead className='table-primary text-dark' >
                                    <tr>
                                        <th className="text-center ">Benefits</th>

                                        {benefitStructure.selectedPlans.map((result, index) => (
                                            <th className="text-center"> {result.planName} ({result.portalPlanType})     </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        benefitStructure.benefitsLeftSide.map((benefitResultMain, index) => (
                                            <tr key={benefitResultMain.benefitId} >
                                                <td className="text-center " >
                                                    <b>
                                                        {benefitResultMain.benefitName}
                                                    </b>
                                                </td>
                                                {benefitStructure.selectedPlans.map((result, indexMain) => (
                                                    <td className="text-center">
                                                        {benefitStructure.planDefaultBenefits.map((benefitResult, index) => (
                                                            result.planId == benefitResult.planId && benefitResultMain.benefitId == benefitResult.benefitId && benefitResult.tobType == appConstants.TOB_TYPE_TOB ?
                                                                <>
                                                                    {/* {benefitStructure.planDefaultBenefits.map((benefitResult1, index) => (
                                                                        <>  */}
                                                                    {/* {benefitResult1.planId == benefitResult.planId && benefitResultMain.benefitId == benefitResult1.benefitId ? benefitResult.benefitValue : ''}   */}
                                                                    {benefitResult.benefitValue}
                                                                    {/* </>
                                                                    ))}  */}
                                                                </>
                                                                : ""
                                                        ))}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    <tr>
                                        <th className="text-center ">Premium</th>

                                        {benefitStructure.selectedPlans.map((result, index) => (
                                            <td className="text-center">
                                                {benefitStructure.premiumDetails.map((benefitResult, index) => (
                                                    result.planId == benefitResult.planId ?
                                                        <>
                                                            {/* {benefitStructure.planDefaultBenefits.map((benefitResult1, index) => (
                                                             <>  */}
                                                            {/* {benefitResult1.planId == benefitResult.planId && benefitResultMain.benefitId == benefitResult1.benefitId ? benefitResult.benefitValue : ''}   */}


                                                            {benefitResult.memberFullName + " :  " + appUtilityFunctions.formatAmount(benefitResult.basePremium)}<br />
                                                            {/* </>
                                                         ))}  */}
                                                        </>
                                                        : ""
                                                ))}
                                            </td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    }

                </div >
            </>
        )
    }

    return (
        <>
            <div >
                <div class="modal-dialog modal-full-width">
                    <div class="modal-content">
                        <div class="modal-header">
                            {/* <div className="ribbon-box">
                                <div className="ribbon ribbon-primary float-start">
                                    <i className="mdi mdi-account-circle-outline me-1"></i>
                                    <i className="mdi mdi-compare-horizontal"></i>   Plans Benefits Comparison
                                </div>
                            </div> */}

                            {/* <button type="button" class="btn-close btn-danger"
                                data-bs-container="#tooltip-container2" data-bs-toggle="tooltip"
                                data-bs-placement="bottom" title="Close"
                                id="individualBenefitStructure" data-bs-dismiss="modal"
                                aria-hidden="true" onClick={() => onResetBenefitStrucutre()}></button> */}

                        </div>

                        {
                            <div>
                                <div class="modal-body">
                                    {renderBenefitStructure()}
                                </div>
                            </div>
                        }

                        <div class="modal-footer">
                            {/* {
                                // <div>  <button type="submit" className="btn btn-danger float-end"
                                //     data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Close"
                                //     id="individualBenefitStructure" data-bs-dismiss="modal"
                                //     aria-hidden="true" onClick={() => onResetBenefitStrucutre()} ><i className="dripicons-cross"></i> Close</button>
                                // </div>
                            } */}

                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}


